import React from 'react';
import PropTypes from 'prop-types';

class ScrollThreshold extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isScrolled: props.threshold()
    };
  }

  onScroll = () => {
    const isScrolled = this.props.threshold();
    if (isScrolled !== this.state.isScrolled) {
      this.setState({ isScrolled });
    }
  };

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  render() {
    return this.props.children(this.state.isScrolled);
  }
}

ScrollThreshold.propTypes = {
  threshold: PropTypes.func.isRequired
};

export default ScrollThreshold;
